export default __webpack_public_path__ + "static/media/work-light.99054e1c.svg";